import React from "react";
import { Form, Input, Button, Checkbox, Spin, Select } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { getTranslation } from "../../../utils/helper";

const UserForm = ({ form, isFetching, user, groups, handleSubmit, handleCancel }) => {
  const userAuth = useSelector(state => state.auth.user);
  const setting = userAuth.company;

  const onChangeCheckboxPassword = e => {
    if (e.target.checked) {
      form.setFieldsValue({
        password: "123123123",
      });
    }
  };

  return (
    <Spin spinning={isFetching}>
      <div className="UserForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
          <div className="FormHeader">
            <div className="left">
              {user ? getTranslation(setting, "Users", "Edit User") : getTranslation(setting, "Users", "Edit User")}
            </div>
          </div>
          <div className="FormContent">
            <Form.Item
              label={getTranslation(setting, "Users", "User Name")}
              name="name"
              rules={[{ required: true, message: "Required" }]}>
              <Input size="large" placeholder={getTranslation(setting, "Users", "User Name")} />
            </Form.Item>
            <Form.Item
              label={getTranslation(setting, "Users", "Email Address")}
              name="email"
              rules={[
                { type: "email", message: "Invalid Email" },
                { required: true, message: "Required" },
              ]}>
              <Input size="large" placeholder={getTranslation(setting, "Users", "Email Address")} />
            </Form.Item>
            <Form.Item label={getTranslation(setting, "Users", "Groups")} name="groups">
              <Select
                size="large"
                showSearch
                optionFilterProp="children"
                mode="multiple"
                showArrow
                placeholder={getTranslation(setting, "Users", "Groups")}>
                {groups.map(c => (
                  <Select.Option key={c._id} value={c._id}>
                    {c.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={getTranslation(setting, "Users", "Password")}
              name="password"
              rules={[{ required: !user, message: "Required" }]}>
              <Input.Password size="large" placeholder={getTranslation(setting, "Users", "Password")} />
            </Form.Item>
            <Form.Item name="passwordDefault" valuePropName="checked">
              <Checkbox onChange={e => onChangeCheckboxPassword(e)}>
                {getTranslation(setting, "Users", "Use default password")}: <b>123123123</b>
              </Checkbox>
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                {getTranslation(setting, "Common", "Cancel")}
              </Button>
              <Button htmlType="submit" type="primary">
                {user ? getTranslation(setting, "Common", "Update") : getTranslation(setting, "Common", "Create")}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default UserForm;
